/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import * as Actions from '../../../actions/actions';

import { Wrapped } from '../../wrapper/VersionWrapper';
import Form from './Form';
import FilterSelector from '../../elements/FilterSelector';

import { DefaultServices } from '../../../constants/DefaultServices';
import { getHeadlineContentFromQuery, DEFAULT_HEADLINE_CONTENT } from '../../../content/HeadlineContent';

import * as EventHandler from '../../../services/EventHandler';

export class ControlSection extends Component {
    getHeadlineContent() {
        let content = DEFAULT_HEADLINE_CONTENT;

        if (this.props.adviserType || this.props.consumerLocation) {
            content = getHeadlineContentFromQuery(this.props.adviserType, this.props.consumerLocation);
        }

        return content;
    }

    componentWillMount() {
        this.WrappedForm = Wrapped(this.controlForm(), this.experimentForm());
    }

    handleFilterClick(adviceArea, needName, key) {
        EventHandler.track('Clicked Need Button', {
            category: 'Landing Page',
            label: needName,
        });

        this.props.actions.updatePersonAttribute('adviceArea', adviceArea);
        if (key) {
            this.props.actions.updatePersonAttribute('needKey', key);
        }

        browserHistory.push('match');
    }

    renderBanner() {
        const content = this.getHeadlineContent();

        return (
            <div className="banner-info">
                <h1 className="hero-banner__header hidden-mobile">
                    <span className="line">{ content.headline.firstLine }&nbsp;</span>
                    <span className="line">{ content.headline.secondLine }</span>
                </h1>
                <h1 className="hero-banner__header mobile-only">
                    <span className="line">{ content.headline.mobile.firstLine }&nbsp;</span>
                    <span className="line">{ content.headline.mobile.secondLine }</span>
                </h1>
                <div className="hero-banner__subtitle">
                    With more than <span className="semi-bold">5,000</span> advisers and
                    <span className="semi-bold"> 60,000</span> reviews,
                    VouchedFor is home to the UK's top mortgage advisers.
                    Simply tell us a little bit about you,
                    and we'll find the perfect adviser to help with your mortgage.
                </div>
            </div>
        );
    }

    controlForm() {
        return (
            <div className="hero-banner__down matching">
                <div id="form-anchor"></div>
                <div className="banner-form">
                    <div className="banner-form__container">
                        <h2>What are you looking for help with?</h2>
                        <FilterSelector filters={ DefaultServices }
                                        handleClick={ this.handleFilterClick.bind(this) } />
                    </div>

                </div>

            </div>
        );
    }

    experimentForm() {
        return (
            <div className="hero-banner__down">
                <div id="form-anchor"></div>
                <div className="banner-form">
                    <div className="banner-form__container">
                        <Form/>
                    </div>
                </div>
            </div>
        );
    }

    renderForm() {
        return <this.WrappedForm/>;
    }

    render() {
        return (
            <div className="app__landing-page__section--full">
                <div className="app__landing-page__full-image hero-banner__image">
                    <div className="opacity-layer">
                        <div className="app__landing-page__hero-banner">
                            <div className="hero-banner__up">
                                { this.renderBanner() }
                            </div>
                            { this.renderForm() }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ControlSection.propTypes = {
    scrollToForm: React.PropTypes.func,

    actions: React.PropTypes.object,

    consumerLocation: React.PropTypes.string,
    adviserType: React.PropTypes.string,
    person: React.PropTypes.object,
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        adviserType: state.reducer.get('adviserType'),
        consumerLocation: state.reducer.get('consumerLocation'),
        person: state.reducer.get('person'),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ControlSection);



// WEBPACK FOOTER //
// ./src/components/steps/landing/ControlSection.jsx